__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-segmentation/v6_16_22/";